"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NameOrZipCodeInput;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _axios = _interopRequireDefault(require("axios"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LIBRARIES_ARRAY = ['places'];
function NameOrZipCodeInput(_ref) {
  var {
    searchState,
    setSearchState,
    searchByName,
    isDesktop,
    shouldNotTriggerAutocomplete,
    onSearch,
    sourcePage,
    placesService,
    autocompleteService,
    isProgrammaticUpdate,
    cancelAutocompleteRef
  } = _ref;
  var labelText = searchByName ? " named " : " near ";
  var placeholderText;
  if (!searchState.searchByName) {
    placeholderText = 'Zip Code or City, State';
  } else if (searchState.finProOrAgencySelection === 'Agency') {
    placeholderText = 'Agency Name';
  } else {
    placeholderText = 'Name';
  }
  var [showAutocomplete, setShowAutocomplete] = (0, _react.useState)(false);
  var [suggestions, setSuggestions] = (0, _react.useState)([]);
  var [selectedIndex, setSelectedIndex] = (0, _react.useState)(-1);
  var [inputValue, setInputValue] = (0, _react.useState)(searchState.nameOrZipCodeInputSelection);
  // Flag for programmatic updates
  var autocompleteRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (isProgrammaticUpdate.current || shouldNotTriggerAutocomplete) {
      isProgrammaticUpdate.current = false; // Reset the flag
      return; // Skip the autocomplete logic
    }

    // debouncing the input and auto-complete call by 500ms
    var handler = setTimeout(() => {
      // Make sure we are at 3 characters, have the service avilable, and that we are not showing autocomplete on load of page
      if (inputValue.length > 2) {
        // If cancelAutocompleteRef is true, do not show autocomplete. As user has already submitted
        if (cancelAutocompleteRef.current) return;
        setShowAutocomplete(true);
        if (!searchState.searchByName) {
          if (autocompleteService.current) {
            autocompleteService.current.getPlacePredictions({
              input: inputValue,
              types: ['locality', 'postal_code'],
              componentRestrictions: {
                country: ['us', 'pr']
              }
            }, (predictions, status) => {
              if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                setSuggestions(predictions);
                setSelectedIndex(-1); // Reset selected index when new suggestions are fetched
              } else {
                setSuggestions([]);
              }
            });
          } else {
            console.error('Autocomplete service not available');
            setSuggestions([]);
          }
        } else if (searchState.searchByName && searchState.finProOrAgencySelection === 'Agency') {
          _axios.default.get('/apicalls/finpro/suggestion/agency?term=' + inputValue).then(res => {
            setSuggestions(res.data.data.suggester);
            setSelectedIndex(-1);
          }, err => {
            setSuggestions([]);
            console.error(err);
          });
        } else {
          _axios.default.get('/apicalls/finpro/suggestion/agent?term=' + inputValue).then(res => {
            setSuggestions(res.data.data.suggester);
            setSelectedIndex(-1);
          }, err => {
            setSuggestions([]);
            console.error(err);
          });
        }
      } else {
        setSuggestions([]);
      }
    }, 500); // Debounce by 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);
  (0, _react.useEffect)(() => {
    var handleClickOutside = event => {
      if (autocompleteRef.current && !autocompleteRef.current.contains(event.target)) {
        setShowAutocomplete(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  (0, _react.useEffect)(() => {
    setInputValue(searchState.nameOrZipCodeInputSelection);
  }, [searchState.nameOrZipCodeInputSelection]);
  var handleInputChange = e => {
    var value = e.target.value;
    setInputValue(value);
    cancelAutocompleteRef.current = false; // Allow autocomplete once a user has changed input
    setSearchState(prevState => {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        nameOrZipCodeInputSelection: value
      });
    });
  };
  var handleKeyDown = e => {
    if (e.key === 'ArrowDown') {
      // Move selection down
      setSelectedIndex(prevIndex => Math.min(prevIndex + 1, suggestions.length - 1));
    } else if (e.key === 'ArrowUp') {
      // Move selection up
      setSelectedIndex(prevIndex => Math.max(prevIndex - 1, 0));
    } else if (e.key === 'Enter' && selectedIndex >= 0) {
      // Select the currently highlighted suggestion
      var selectedSuggestion = suggestions[selectedIndex];
      if (selectedSuggestion) selectSuggestion(selectedSuggestion);
    } else if (e.key === 'Enter' && selectedIndex === -1) {
      setShowAutocomplete(false);
    }
  };
  var selectSuggestion = suggestion => {
    isProgrammaticUpdate.current = true; // Set the flag for programmatic update
    // Select Suggestion for searchByName
    if (searchState.searchByName) {
      setInputValue(suggestion.term);
      setSearchState(prevState => {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          lastSearchedTerm: suggestion.term,
          lastSearchedWasByName: true,
          nameOrZipCodeInputSelection: suggestion.term,
          lat: 0,
          lng: 0,
          distanceMiles: 5,
          distanceFilterSelectionIndex: 1,
          languageSelection: [],
          specialtySelection: []
        });
      });
      setShowAutocomplete(false);
      setSuggestions([]);
      if (sourcePage !== 'home') {
        onSearch();
      } else {
        // We cannot assume that our searchData is updated with the proper data upon the autcomplete selection on the homepage
        localStorage.setItem('searchData', JSON.stringify(_objectSpread(_objectSpread({}, searchState), {}, {
          lastSearchedTerm: suggestion.term,
          lastSearchedWasByName: true,
          nameOrZipCodeInputSelection: suggestion.term,
          lat: 0,
          lng: 0,
          languageSelection: [],
          specialtySelection: [],
          distnaceMiles: 5,
          distanceFilterSelectionIndex: 1
        })));
        window.location.href = '/search';
      }
    } else {
      // Select suggestion for seachByLocation
      setInputValue(suggestion.description);
      placesService.current.getDetails({
        placeId: suggestion.place_id
      }, (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          var {
            lat,
            lng
          } = place.geometry.location;
          setSearchState(prevState => {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              lastSearchedTerm: suggestion.description,
              lastSearchedWasByName: false,
              nameOrZipCodeInputSelection: suggestion.description,
              nameOrZipCodeInputPlaceId: suggestion.place_id,
              lat: lat(),
              lng: lng(),
              distanceMiles: 5,
              distanceFilterSelectionIndex: 1,
              languageSelection: [],
              specialtySelection: []
            });
          });
          setShowAutocomplete(false);
          setSuggestions([]);
          if (sourcePage !== 'home') {
            onSearch();
          } else {
            // We cannot assume that our searchData is updated with the proper data upon the autcomplete selection on the homepage
            localStorage.setItem('searchData', JSON.stringify(_objectSpread(_objectSpread({}, searchState), {}, {
              lastSearchedTerm: suggestion.description,
              lastSearchedWasByName: false,
              nameOrZipCodeInputSelection: suggestion.description,
              nameOrZipCodeInputPlaceId: suggestion.place_id,
              lat: lat(),
              lng: lng(),
              languageSelection: [],
              specialtySelection: [],
              distnaceMiles: 5,
              distanceFilterSelectionIndex: 1
            })));
            window.location.href = '/search';
          }
        }
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    className: "copy-lg ".concat(isDesktop ? 'add-margin-left add-margin-right' : 'add-margin-bottom'),
    htmlFor: 'name-or-zipcode-input'
  }, /*#__PURE__*/_react.default.createElement("strong", null, labelText)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "form-group name-or-zipcode-form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "name-or-zipcode-input"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    id: 'name-or-zipcode-input',
    type: 'text',
    inputMode: 'text',
    maxLength: 100,
    autoComplete: "off",
    value: inputValue,
    placeholder: placeholderText,
    onChange: handleInputChange,
    htmlSize: isDesktop ? 25 : '',
    onKeyDown: handleKeyDown
  })), showAutocomplete && searchState.nameOrZipCodeInputSelection.length > 2 && suggestions ? /*#__PURE__*/_react.default.createElement("ul", {
    className: "finpro-auto-complete",
    ref: autocompleteRef
  }, suggestions.length > 0 ? suggestions.map((suggestion, index) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      className: index === selectedIndex ? 'selected' : '',
      onMouseEnter: () => {
        setSelectedIndex(index);
      },
      onMouseLeave: () => {
        setSelectedIndex(-1);
      },
      onClick: e => {
        selectSuggestion(suggestion);
      }
    }, searchState.searchByName ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "".concat(suggestion.term, " "), /*#__PURE__*/_react.default.createElement("span", {
      className: "suggestion-location"
    }, suggestion.payload)) : suggestion.description);
  }) : /*#__PURE__*/_react.default.createElement("li", {
    className: "no-matches"
  }, "No Matches Found")) : ''));
}